import { render, staticRenderFns } from "./TextWithStatusEl.vue?vue&type=template&id=567721c6&scoped=true&"
import script from "./TextWithStatusEl.vue?vue&type=script&lang=ts&"
export * from "./TextWithStatusEl.vue?vue&type=script&lang=ts&"
import style0 from "./TextWithStatusEl.vue?vue&type=style&index=0&id=567721c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567721c6",
  null
  
)

export default component.exports